<template lang="html">
  <div :class="{content: true, user: activeTab === '已授权'}">
    <div :class="{bg: true, un: activeTab === '已授权'}" v-show="!modifyAccount">
      <div class="tabs">
        <p v-if="(t === '账户设置' && showAuth.account_config) || (t === '账户安全' && showAuth.account_safe) || (t === '部门角色' && showAuth.department_role) || (t === '已授权' && showAuth.has_new_media)" :class="{tab: true, active: t === activeTab}" v-for="(t, i) in tabs" :key="i" @click="toggleTab(t)">{{t}}</p>
      </div>
      <div class="account" v-show="activeTab === '账户设置'">
        <div class="avatar">
          <div @mouseenter="mouseHover = true" @mouseleave="mouseHover = false" class="img">
            <img @imgError="setNewImg" :src="avatar" alt="avatar">
            <p class="mask" id="picBtn">修改头像</p>
          </div>
          <p v-show="mouseHover" class="tip">
            图片不能超过20mb
          </p>
          <p v-show="!mouseHover" class="name">{{user.truename}}</p>
        </div>
        <div class="item">
          <div class="left">
            <span class="title">
              用户名
            </span>
            <input type="text" :class="{detail: true, disabled: fixUser}" v-model="user.name" :disabled="fixUser">
          </div>
          <p class="btn" v-if="!fixUser">修改</p>
        </div>
        <div class="item">
          <div class="left">
            <span class="title">
              手机
            </span>
            <span class="detail">{{`${user.tel.substr(0, 3)}****${user.tel.substr(7, 4)}`}}</span>
            <!-- <input disabled type="text" class="detail" v-model="user.tel"> -->
          </div>
          <p v-if="showAuth.change_phone" class="btn" @click="goModifyTel()">修改</p>
        </div>
        <div class="item">
          <div class="left">
            <span class="title">
              邮箱
            </span>
            <input ref="setEmail" :disabled="setEmail" type="text" class="detail" v-model="user.email">
          </div>
          <!-- greenBtn -->
          <p class="btn" v-if="setEmail && user.tel.length > 0" @click="modifyEmail()">修改</p>
          <p class="btn" v-if="!setEmail && user.tel.length > 0" @click="checkEmail">保存</p>
        </div>
        <div v-show="showRelative" class="platformMask">
          <div class="platformBox">
            <div class="title">此次邮箱修改将同步至：</div>
            <div class="content">
              <ul>
                <li v-for="(item,index) in relativeSystem" :key="index">{{item.title}}</li>
              </ul>
            </div>
            <div class="btns">
              <div @click="saveEmail();showRelative = false;" class="btn on">确定</div>
              <div @click="showRelative = false;" class="btn">取消</div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="left">
            <span class="title">
              工号
            </span>
            <input disabled type="text" class="detail" v-model="user.card">
          </div>
          <p class="btn" v-show="false">重新绑定</p>
        </div>
        <div v-show="user.has_meizi" class="item">
          <div class="left">
            <span class="title">
              媒资账号
            </span>
            <input disabled type="text" class="detail" v-model="user.meizi">
          </div>
          <p class="btn" @click='bindMZ' v-if="!user.meizi">绑定</p>
          <p class="btn" @click='bindMZ' v-else>重新绑定</p>
        </div>
      </div>  
      <div class="safe" v-show="activeTab === '账户安全'">
        <div class="note">
          <img src="@assets/img/user/note.svg" alt="note">
          <span>
            为了您的密码安全，建议半年换一次密码
          </span>
        </div>
        <div class="item">
          <div class="left">
            <span class="title">
              原密码
            </span>
            <input type="password" class="detail" v-model="reset.origin" placeholder="请输入原密码" maxlength="16">
          </div>
        </div>
        <div class="item">
          <div class="left">
            <span class="title">
              新密码
            </span>
            <input type="password" class="detail" v-model="reset.new" placeholder="请输入新密码" maxlength="16">
          </div>
        </div>
        <div class="item">
          <div class="left">
            <span class="title">
              新密码确认
            </span>
            <input type="password" class="detail" v-model="reset.new2" placeholder="请再次输入新密码" maxlength="16">
          </div>
        </div>
        <div class="tip">
          <img src="@assets/img/user/tip.svg" alt="tip">
          <span>8-16位 (含大、小写字母+数字+特殊字符) 特殊字符仅包含：~!@#$%^&*()\-_=+{};:<,.>?</span>
        </div>
      </div>
      <div class="safe charater" v-show="activeTab === '部门角色'">
        <div class="item" v-for="(d, i) in deps.departs" :key="i">
          <div class="left">
            <span class="title depTitle">
              <!-- {{deps.product_name}} -->
              {{d.depart_title}}
            </span>
            <span class="detail long">{{d.roles.map(i => i.role_name).join(' , ')}}</span>
            <!-- <input disabled type="text" v-model="d.role.map(i => i.title).join(' , ')" class="detail long"  placeholder="请输入原密码" maxlength="16"> -->
          </div>
        </div>
      </div>
      <div class="authPlatform" v-show="activeTab === '已授权'">
        <div class="paltform-container">
          <ul>
            <li v-for="(item,index) in platforms" :key="index" @click="platformIndex = index" :class="{on: platformIndex == index}">
              <i :class="{kankan: item.platform_key == 'new_media_knews', b: item.platform_key == 'b_plus', dy: item.platform_key == 'dy', sport: item.platform_key == 'five_star_sports_cms', bili: item.platform_key == 'bilibili'}"></i>
            </li>
          </ul>
        </div>
        <div class="column-container">
          <ul>
            <li v-for="(item,index) in platforms.length > 0 && platforms[platformIndex].columns" :key="index" @click="columnIndex = index;getnewMediaPlatformUser();getProcess()" :class="{on: columnIndex == index, err: item.blocked_info.is_block}">{{item.column_title}}</li>
          </ul>
          <div v-if="showBplus" @click="addCount(platforms[platformIndex].platform_key)" class="addCount">
            <img src="@assets/img/mediaPublish/addIcon.png" alt="">
            <p>添加账号</p>
          </div>
        </div>
        <div class="usercontent-container">
          <div v-if="blocked_info.is_block" class="alertTips"><i></i><p>{{ blocked_info.block_msg }}</p></div>
          <div v-if="platforms[platformIndex] && platforms[platformIndex].columns.length > 0" class="content-container">
            <div class="title">
              <div class="left">
                <i :class="{kankan: platforms[platformIndex].platform_key == 'new_media_knews', b: platforms[platformIndex].platform_key == 'b_plus', dy: platforms[platformIndex].platform_key == 'dy', sport: platforms[platformIndex].platform_key == 'five_star_sports_cms', bili: platforms[platformIndex].platform_key == 'bilibili'}"></i>
                <p>{{platforms[platformIndex].platform_title}} - {{platforms[platformIndex].columns[columnIndex].column_title}}</p>
              </div>
              <div v-click-outside="peopleClickOut" v-if="!showBplus" class="right relative">
                <div v-show="userlist.length > 0" class="btn out" @click="peopleOut">人员导出</div>
                <ul v-if="showPeopleOut">
                  <li @click="peopleOut">当前栏目/账号</li>
                  <!-- <li @click="peopleOut('all')">全部栏目/账号</li> -->
                </ul>
              </div>
              <div v-if="showBplus" class="right">
                <p v-if="!platforms[platformIndex].columns[columnIndex].is_expire">令牌将在<i :class="{orange: platforms[platformIndex].columns[columnIndex].color == 'orange'}">{{platforms[platformIndex].columns[columnIndex].expire_at}}</i>过期</p>
                <p v-if="platforms[platformIndex].columns[columnIndex].is_expire" class="red">令牌已过期</p>
                <div  @click="addCount(platforms[platformIndex].platform_key)" :class="{btn: true,red: platforms[platformIndex].columns[columnIndex].is_expire, orange: platforms[platformIndex].columns[columnIndex].color == 'orange'}">重新绑定</div>
                <div v-click-outside="peopleClickOut" class="relative">
                  <div v-show="userlist.length > 0" class="btn" @click="peopleOut">人员导出</div>
                  <ul v-if="showPeopleOut">
                    <li @click="peopleOut">当前栏目/账号</li>
                    <!-- <li @click="peopleOut('all')">全部栏目/账号</li> -->
                  </ul>
                </div>
            </div>
            </div>
            <div v-if="adminList && adminList.title" class="admin">
              <div class="left">
                <p>{{adminList.title}}</p>
                <div v-for="(item,index) in adminList.users" :key="index" @click="showEditorCard(item,$event)" class="img">
                  <i :style="'background-image: url('+item.avatar+')'"></i>
                  <span>{{item.truename}}</span>
                </div>
              </div>
              <!-- <div class="right">编辑</div> -->
            </div>
            <div class="content">
              <div class="title">
                <i></i>
                <p>{{platforms.length > 0 && platforms[platformIndex].columns && platforms[platformIndex].columns[columnIndex] && platforms[platformIndex].columns[columnIndex].column_title}}</p>
                <div>
                  (已授权
                  <i>{{listNum}}</i>
                  人)
                </div>
                <!-- <p class="tips">跳审/审核隔离</p> -->
                <div v-if="userlist.length > 0" class="roleStatus">
                  <p class="t">当前审核流程:</p>
                  <p class="t">{{processName}}</p>
                  <span @click="setRole(platforms[platformIndex].platform_title + '-' + platforms[platformIndex].columns[columnIndex].column_title)" v-if="hasAdmin">更改</span>
                </div>
              </div>
              <div v-if="userlist.length == 0" class="addProcess">
                <img src="@assets/img/user/empty.png" alt="">
                <div v-show="hasAdmin" @click="setRole(platforms[platformIndex].platform_title + '-' + platforms[platformIndex].columns[columnIndex].column_title)" class="btn">审核流程配置</div>
                <p>温馨提示：未配置流程将无法发布稿件</p>
              </div>
              <div v-if="userlist.length > 0" class="listTitle">
                <p class="role">角色</p>
                <p class="user">用户</p>
                <div class="edit">
                  <!-- <p>审核角色跳过审核</p>
                  <div @click="changeVerify" :class="{un: platforms.length > 0 && platforms[platformIndex].columns && platforms[platformIndex].columns[columnIndex] && platforms[platformIndex].columns[columnIndex].jump_verify == 0}">
                    <i></i>
                  </div> -->
                </div>
              </div>
              <ul v-if="userlist.length > 0" class="list">
                <li v-for="(item,index) in userlist" :key="index">
                  <div class="left">{{item.title}}  (<span>{{item.users.length}}</span>人)</div>
                  <div class="right">
                    <div v-for="(val,key) in item.users" :key="key" class="editorCard" @click="showEditorCard(val,$event)">
                      <i :style="'background-image: url('+val.avatar+')'"></i>
                      <p>{{val.truename}}</p>
                    </div>
                    <div v-if="hasAdmin" @click="addMember(platforms[platformIndex].platform_key,platforms[platformIndex].columns[columnIndex].column_key,item.role_type)" class="add">
                      
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg" v-show="modifyAccount === 'mz'">
      <div class="breadline">
        <span class="bold" @click="modifyAccount = '';getUser()">账户设置</span>
        >
        <span>媒资账号绑定</span>
      </div>
      <div class="steps">
        <div class="step" v-for="(s, i) in setMz.list" :key="i">
          <div :class="{order: true, on: i+1 == setMz.stage}">
            <div :class="{core: true, on: i+1 == setMz.stage}">
              {{i + 1}}
            </div>
          </div>
          <div :class="{name: true, on: i+1 == setTel.stage}">{{s.title}}</div>
          <div class="line"></div>
        </div>
      </div>

      <div v-if="setMz.stage==1" class="mzContent">
        <input v-model='setMz.bind.username' placeholder="请输入媒资网用户名" />
        <!-- todo 是明文密码？ -->
        <input v-model='setMz.bind.password' type="password" placeholder="请输入密码" />
      </div>

      <div v-if="setMz.stage==1" @click="bindMZNext" class="mzBtn">下一步</div>

      <div v-if="setMz.stage==2" class="mzOk">
        <img class="okimg" src="@assets/img/common/ok.svg" alt="ok">
        <p class="okmessage">绑定成功！</p>
        <div class="btn">
          <p @click="modifyAccount = '';getUser()">返回账户设置</p>
          <!-- todo 进入直接是登录状态 带token -->
          <p @click="navigateToMZ">进入媒资网</p>
        </div>
      </div>

    </div>

    <div class="bg" v-show="modifyAccount === 'tel'">
      <div class="breadline">
        <span class="bold" @click="modifyAccount = '';getUser()">账户设置</span>
        >
        <span>设置手机</span>
      </div>
      <div class="steps">
        <div class="step" v-for="(s, k, i) in setTel.steps" :key="i">
          <div :class="{order: true, on: k == setTel.stage}">
            <div :class="{core: true, on: k == setTel.stage}">
              {{i + 1}}
            </div>
          </div>
          <div :class="{name: true, on: k == setTel.stage}">{{s.title}}</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="modify" v-if="setTel.stage === 'check'">
        <div class="tel">
          <span class="title">原手机号</span>
          |
          <input class="disable" disabled type="text" v-model="setTel.steps.check.tel" maxlength="11">
        </div>
        <div class="verify">
          <input type="number" v-model="setTel.steps.check.verify" placeholder="请输入手机验证码">
          <div :class="{send: true, disable: setTel.steps.check.msg}" @click="setTel.steps.check.send(setTel.steps.check)">{{setTel.steps.check.msg || '发送验证码'}}</div>
        </div>
        <div class="next" @click="setTel.steps.check.next(setTel.steps.check)">下一步</div>
      </div>
      <div class="modify" v-if="setTel.stage === 'bind'">
        <div class="tel">
          <span class="title">
            中国大陆
            <img src="@assets/img/common/xiala.svg" alt="icon">
          </span>
          |
          <input type="text" v-model="setTel.steps.bind.tel" maxlength="11">
        </div>
        <div class="verify">
          <input type="number" v-model="setTel.steps.bind.verify" placeholder="请输入手机验证码">
          <div :class="{send: true, disable: setTel.steps.bind.msg}" @click="setTel.steps.bind.send(setTel.steps.bind)">{{setTel.steps.bind.msg || '发送验证码'}}</div>
        </div>
        <div class="next" @click="setTel.steps.bind.next(setTel.steps.bind)">下一步</div>
      </div>
      <div class="modify" v-if="setTel.stage === 'success'">
        <img class="okimg" src="@assets/img/common/ok.svg" alt="ok">
        <p class="okmessage">绑定成功！</p>
        <div class="next" @click="modifyAccount = '';getUser()">返回账户设置</div>
      </div>
    </div>
    <div class="footline" v-show="activeTab === '账户安全'" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <p class="btn" @click="resetPwd">
        保存
      </p>
    </div>
    <div class="modifyBox" v-if="modifyTel.show">
      <div class="box">
        <div class="topline">
          <p class="title">修改手机号</p>
          <img src="@assets/img/common/close.svg" alt="close" @click="modifyTel.close()">
        </div>
        <div class="line">
          <input type="text" placeholder="请输入手机号" v-model="modifyTel.tel">
        </div>
        <div class="line">
          <input type="text" placeholder="请输入短信验证码" v-model="modifyTel.code">
          <div @click="sendVerify()" :class="{btn: true, greenBtn: true, disable: countDown.active}">{{countDown.text || '发送验证码'}}</div>
        </div>
        <div class="btn big greenBtn" @click="saveTel()">保存</div>
      </div>
    </div>

    <div v-show="showPasswordRelative" class="platformMask">
      <div class="platformBox">
        <div class="title">此次密码修改将同步至：</div>
        <div class="content">
          <ul>
            <li v-for="(item,index) in relativeSystem" :key="index">{{item.title}}</li>
          </ul>
        </div>
        <div class="btns">
          <div @click="resetPwd1();showPasswordRelative = false;" class="btn on">确定</div>
          <div @click="showPasswordRelative = false;" class="btn">取消</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import * as config from '@common/config'
import dc from '@common/dc'
import vClickOutside from 'v-click-outside'

export default {
  name: 'user',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      showPeopleOut: false,
      showPasswordRelative: false,
      showRelative: false,
      relativeSystem: [],
      processList: [],
      adminList: {},
      hasAdmin: false,
      processName: '',
      userlist: [],
      listNum: 0,
      platformIndex: 0,
      columnIndex: 0,
      avatar: require('@assets/img/common/defaultAvatar.png'),
      tabs: [
        '账户设置', '账户安全', '部门角色', '已授权'
      ],
      activeTab: '',
      fixUser: true,
      mouseHover: false,
      user: {
        name: '',
        tel: '',
        email: '',
        wx: '',
        meizi:'',
        has_meizi: false,
        truename: '',
        card: ''
      },
      reset: {
        origin: '',
        new: '',
        new2: ''
      },
      modifyTel: {
        show: false,
        tel: '',
        code: '',
        close: () => {
          this.modifyTel.show = false
        },
        open: () => {
          this.modifyTel.show = true
        }
      },
      countDown: {
        durantion: 60,
        count: null,
        seconds: 60,
        text: '',
        active: false
      },
      deps: {},
      baseUrl: '',
      appId: '',
      appSecret: '',
      picStream: null,
      picConfig: {
        browseFileId: 'picBtn',
        extFilters: ['.jpg', '.png', '.gif', '.jpeg'],
        maxSize: 20*1024*1024,
        customered: true,
        autoUploading: true,
        multipleFiles: false,
        retryCount: 3,
        tokenURL: '',
        uploadURL: '',
        postVarsPerFile : {
            appId: '',
            appSecret: ''
        },
        onComplete: (f) => {
          const path = (JSON.parse(f.msg)).targetPath

          this.changeAvatar(path)
        },
        onUploadError: (f) => {
          this.$toast('修改头像失败')
        },
        onMaxSizeExceed: (f) => {
          console.log('exceed', f)
          this.$toast('图片不能超过20MB')
        }
      },
      modifyAccount: '',
      setEmail: true,
      setMz: {
        bind:{
          username:'',
          password:''
        },
        stage: 1,
        list: [
          {title: '绑定媒资账号'},
          {title: '绑定成功'}
        ]
      },
      setTel: {
        // 设置手机号
        stage: '',
        steps: {
          check: {
            title: '验证身份',
            tel: '',
            verify: '',
            msg: '',
            seconds: 60,
            countDown: null,
            send: (mdl) => {
              if (mdl.countDown) return
              const tel = this.user.tel
              if (tel.length !== 11) {
                this.$toast('请输入正确的手机号')
                return
              }

              const info = {
                phone: tel,
                action: 'checking'
              }
              common.myFetch(config.apis.Usr_sendVerify, info)
              .then((data) => {
                if (data) {
                  this.$toast(data)
                  mdl.count(mdl)
                }
              })
            },
            count: (mdl) => {
              mdl.countDown = setInterval(() => {
                mdl.seconds -= 1
                mdl.msg = `${mdl.seconds} s`
                if (mdl.seconds < 0) {
                  clearInterval(mdl.countDown)
                  mdl.countDown = null
                  mdl.msg = ''
                  mdl.seconds = 60
                }
              }, 1000)
            },
            next: (mdl) => {
              const code = mdl.verify
              const info = {
                code: code,
                action: 'checking',
                phone: code
              }

              common.myFetch(config.apis.Usr_checkVerufy, info)
              .then((r) => {
                if (r) {
                  mdl.verify = ''
                  if(!r.needReBind){
                    this.setTel.stage = 'bind'
                  }
                }else{
                  mdl.verify = ''
                }
              })
            }
          },
          bind: {
            title: '绑定手机',
            tel: '',
            verify: '',
            msg: '',
            seconds: 60,
            countDown: null,
            send: (mdl) => {
              if (mdl.countDown) return
              const tel = mdl.tel
              if (tel.length !== 11) {
                this.$toast('请输入正确的手机号')
                return
              }

              const info = {
                phone: tel,
                action: 'binding'
              }
              common.myFetch(config.apis.Usr_sendVerify, info)
              .then((data) => {
                if (data) {
                  this.$toast(data)
                  mdl.count(mdl)
                }
              })
            },
            count: (mdl) => {
              mdl.countDown = setInterval(() => {
                mdl.seconds -= 1
                mdl.msg = `${mdl.seconds} s`
                if (mdl.seconds < 0) {
                  clearInterval(mdl.countDown)
                  mdl.countDown = null
                  mdl.msg = ''
                  mdl.seconds = 60
                }
              }, 1000)
            },
            next: (mdl) => {
              const tel = mdl.tel
              const code = mdl.verify
              const info = {
                code: code,
                action: 'binding',
                phone: tel
              }

              common.myFetch(config.apis.Usr_checkVerufy, info)
              .then((r) => {
                if (r) {
                  mdl.verify = ''
                  if(!r.needReBind){
                    this.setTel.stage = 'success'
                  }
                }else{
                  mdl.verify = ''
                }
              })
            }
          },
          success: {
            title: '绑定成功'
          }
        }
      },
      footLineGap: 230,
      showAuth: {
        department_role: true,
        account_config: true,
        account_safe: true,
        change_phone: false,
        auth: true
      },
      platforms: [],
      showBplus: false,
      blocked_info: {
        block_msg: "",
        is_block: false
      }
    }
  },
  watch: {
    platformIndex(to) {
      this.columnIndex = 0
      console.log(this.platforms[to])
      if(this.platforms[to].platform_key == 'b_plus' || this.platforms[to].platform_key == 'dy' || this.platforms[to].platform_key == 'bilibili'){
        this.showBplus = true
      }else{
        this.showBplus = false
      }
      if(this.platforms[to] && this.platforms[to].columns.length > 0){
        this.getnewMediaPlatformUser()
        this.getProcess()
      }
    }
  },
  methods: {
    peopleClickOut() {
      this.showPeopleOut = false;
    },
    peopleOut(type) {
      if(type == 'all'){
        let info = {
          platform_key: this.platforms[this.platformIndex].platform_key,
          column_key: ''
        }

        const userKeys = common.userKeys()
        const params = Object.assign({}, info, userKeys)
        const url = config.apis.downloadplatformusers

        common.exportRes(url, params)
        this.showPeopleOut = false;
      }else{
        let info = {
          platform_key: this.platforms[this.platformIndex].platform_key,
          column_key: this.platforms[this.platformIndex].columns[this.columnIndex].column_key
        }

        const userKeys = common.userKeys()
        const params = Object.assign({}, info, userKeys)
        const url = config.apis.downloadplatformusers

        common.exportRes(url, params)
        this.showPeopleOut = false;
      }
    },
    checkEmail() {
      var str = this.user.email;
      var box = /([\w\-]+\@[\w\-]+\.[\w\-]+)/;
      if(box.exec(str)){
        this.showRelative = true
      }else{
        this.$toast('该邮箱已存在/该邮箱地址不规范，请重试')
      }
      // console.log(box.exec(str))
    },
    getRedirectSystems() {
      common.myFetch(config.apis.getRedirectSystems).then(res => {
        if (res) {
          this.relativeSystem = res.list
        }
      });
    },
    setRole(title,id) {
      this.$auditProcess({
        title,
        id: id,
        platform_key: this.platforms[this.platformIndex].platform_key,
        column_key: this.platforms[this.platformIndex].columns[this.columnIndex].column_key
      }).then(res => {
        if(res){
          this.getnewMediaPlatformUser()
          this.getProcess();
        }
      })
      // let config1 = {
      //   title,
      //   processList: this.processList
      // }
      // this.$SelectDialog(config1).then(res => {
      //   if(res) {
      //     let id = 0;
      //     res.forEach(el => {
      //       if(el.selected){
      //         id = el.key
      //       }
      //     })

      //     let info = {
      //       process: id,
      //       platform_key: this.platforms[this.platformIndex].platform_key,
      //       column_key: this.platforms[this.platformIndex].columns[this.columnIndex].column_key
      //     }

      //     console.log(config.apis.newMediaSubmitprocess)

      //     common
      //     .myFetch(config.apis.newMediaSubmitprocess, info)
      //     .then(r => {
      //         if (r) {
      //             // console.log(r)
      //             this.$toast(r)
      //             this.getnewMediaPlatformUser()
      //             // if(this.platforms[this.platformIndex].columns.length > 0){
      //               this.getProcess();
      //             // }
      //         }
      //     });
      //   }
      // })
    },
    getProcess() {
      console.log(this.platforms,this.platformIndex)
      let info = {
        platform_key: this.platforms[this.platformIndex].platform_key,
        column_key: this.platforms[this.platformIndex].columns[this.columnIndex].column_key
      }

      common
      .myFetch(config.apis.newMediaProcess, info)
      .then(r => {
          if (r) {
              // console.log(r)
              this.blocked_info = r.blocked_info
              this.processList = r.list
          }
      });
    },
    addCount(platform_key) {
      console.log(platform_key)
      if(platform_key == 'dy'){
        let info = {};
        common
        .myFetch(config.apis.getDyUrl, info)
        .then(r => {
            if (r) {
                console.log(r)
                window.open(r.url)
                // common.jump(r.url,true)
            }
        });

        let config1 = {
            title: '绑定完成前，请不要关闭此验证窗口<br>请在完成绑定后，依实际情况点击以下按钮',
            content: '',
            btn1: '绑定成功',
            btn2: '暂不绑定',
            showIcon: true,
            showAlert: true
        }

        this.$MediaPlatformNotify(config1).then(e => {
            // console.log(e)
            if(e){
              this.getNewMediaPlatform()
            }
        })
      }else if(platform_key == 'bilibili'){
        let info = {};
        common
        .myFetch(config.apis.getbiliurl, info)
        .then(r => {
            if (r) {
                console.log(r)
                window.open(r.url)
                // common.jump(r.url,true)
            }
        });

        let config1 = {
            title: '绑定完成前，请不要关闭此验证窗口<br>请在完成绑定后，依实际情况点击以下按钮',
            content: '',
            btn1: '绑定成功',
            btn2: '暂不绑定',
            showIcon: true,
            showAlert: true
        }

        this.$MediaPlatformNotify(config1).then(e => {
            // console.log(e)
            if(e){
              this.getNewMediaPlatform()
            }
        })
      }else{
        this.$BPlus(platform_key).then(res => {
          if(res) {
            this.getNewMediaPlatform()
          }
        }) 
      }
    },
    addMember(platform_key,column_key,role_type) {
      let obj = {
        platform_key,
        column_key,
        role_type
      }
      this.$MediaPlatformManage(obj).then((e) => {
        console.log(e)
        if(e){
          this.getnewMediaPlatformUser()
          this.getProcess();
        }
      })
    },
    changeVerify() {
      if(this.platforms[this.platformIndex].columns[this.columnIndex].jump_verify == 0){
        this.platforms[this.platformIndex].columns[this.columnIndex].jump_verify = 1
      }else{
        this.platforms[this.platformIndex].columns[this.columnIndex].jump_verify = 0
      }

      try {
        let info = {
          column_key: this.platforms[this.platformIndex].columns[this.columnIndex].column_key,
          jump_verify: this.platforms[this.platformIndex].columns[this.columnIndex].jump_verify
        };
        common
        .myFetch(config.apis.newMediaPlatformSetverify, info)
        .then(r => {
            if (r) {
                this.$toast(r)
                console.log(r)
            // console.log("lock", r);
            }
        });
      } catch (e) {
        console.log("publish_lock e", e);
      }
    },
    getnewMediaPlatformUser() {
      try {
        let info = {
          platform_key: this.platforms[this.platformIndex].platform_key,
          column_key: this.platforms[this.platformIndex].columns[this.columnIndex].column_key
        };
        common
        .myFetch(config.apis.newMediaPlatformUser, info)
        .then(r => {
            if (r) {
                console.log(r)
                this.hasAdmin = r.hasAdmin
                this.processName = r.processName
                let adminList = {}
                r.roles.forEach(el => {
                  if(el.role_type == 'guanliyuan'){
                    adminList = el
                  }
                })
                this.adminList = adminList
                this.userlist = r.roles.filter(el => {
                  return el.role_type != 'guanliyuan'
                });
                let num = 0;
                this.userlist.forEach(el => {
                  num += el.users.length
                })
                // this.listNum = num
                this.listNum = r.totalNum
            // console.log("lock", r);
            }
        });
      } catch (e) {
        console.log("publish_lock e", e);
      }
    },
    getNewMediaPlatform() {
      try {
        common
        .myFetch(config.apis.newMediaPlatform)
        .then(r => {
            if (r) {
                console.log(r)
                this.platforms = r.platforms
                if(r.platforms.length > 0){
                  if(r.platforms[0].platform_key == 'b_plus' || r.platforms[0].platform_key == 'dy' || r.platforms[0].platform_key == 'bilibili'){
                    this.showBplus = true
                  }
                  if(r.platforms[this.platformIndex].columns.length > 0){
                    this.getnewMediaPlatformUser()
                    this.getProcess()
                  }
                }
            // console.log("lock", r);
            }
        });
      } catch (e) {
        console.log("publish_lock e", e);
      }
    },
    showEditorCard(val,e) {
      const el = e.target
      console.log(el)
      this.$EditorCard(val, el)
    },
    navigateToMZ() {
      let info = {};
      common.myFetch(config.apis.Usr_getlogintoken, info).then(r => {
        console.log(r);
        if (r) {
          common.jumpOut(r.host + "middle.html#/" + r.login_token);
          // this.$toast("修改成功");
        }
      });
    },
    setNewImg() {
      this.avatar = require('@assets/img/common/defaultAvatar.png')
    },
    bindMZ(){
      this.modifyAccount='mz'
    },
    clearMz(){
      this.modifyAccount=''
      this.setMz.bind = {
         username:'',
          password:''
      }
       this.setMz.stage = 1
    },
    bindMZNext(){
      common.myFetch(config.apis.Usr_linkmeizi, this.setMz.bind)
              .then((data) => {
                if (data) {
                   this.setMz.stage=2
                   this.setMz.bind.username=''
                   this.setMz.bind.password=''
                }
                // 绑定失败 
                else {

                }
              })
     
    },
    modifyEmail() {
      this.setEmail = false
      this.$nextTick(() => {
        this.$refs.setEmail.focus()
      })
    },
    goModifyTel() {
      // 切换修改手机号事件
      const tel = this.user.tel + ''

      if (tel) {
        this.setTel.steps.check.tel = `${tel.substr(0, 3)}****${tel.substr(7, 4)}`
        this.setTel.stage = 'check'
      } else {
        this.setTel.stage = 'bind'
      }

      this.modifyAccount = 'tel'
    },
    toggleTab(t) {
      console.log(t)
      this.activeTab = t
    },
    getUser() {
      common.myFetch(config.apis.Usr_menu, {})
      .then(r => {
        if (r) {
          this.avatar = r.avatar || this.avatar
          this.user.name = r.username
          this.user.tel = r.phone
          this.user.email = r.email
          this.user.wx = r.wx || ''
          this.deps = r.roles
          this.user.meizi = r.meizi_username
          this.user.has_meizi = r.has_meizi
          this.user.truename = r.truename
          this.user.card = r.card
          this.setMz =  {
              bind:{
                username:'',
                password:''
              },
              stage: 1,
              list: [
                {title: '绑定媒资账号'},
                {title: '绑定成功'}
              ]
            }
          // this.setMz = {...this.setMz,bound:r.meizi_username}
        }
      })
    },
    sendVerify() {
      if (this.countDown.active) {
        return
      }

      if (this.modifyTel.tel.length !== 11) {
        this.$toast('请输入正确的手机号')
        return
      }

      const info = {
        phone: this.modifyTel.tel
      }

      common.myFetch(config.apis.Usr_send, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.startCountDown()
        }
      })
    },
    startCountDown() {
      this.countDown.count = setInterval(() => {
        this.countDown.active = true
        this.countDown.text = `${this.countDown.seconds} s`
        this.countDown.seconds -= 1
        if (this.countDown.seconds < 0) {
          clearInterval(this.countDown.count)
          this.countDown.text = ''
          this.countDown.active = false
          this.countDown.seconds = this.countDown.durantion
        }
      }, 1000)
    },
    saveTel() {
      // 更新手机号
      const data = {
        phone: this.modifyTel.tel,
        code: this.modifyTel.code
      }

      this.saveUser(data)
    },
    saveEmail() {
      const data = {
        email: this.user.email
      }

      if (!this.user.email) {
        this.$toast('邮箱不能为空')
        
        return
      }

      if (this.user.email.indexOf('@') < 0 || this.user.email.indexOf('.') < 0) {
        this.$toast('请输入正确的邮箱')
        
        return
      }

      this.saveUser(data)
      this.setEmail = true
    },
    saveUser(data = {}) {
      // 更新用户信息
      const info = {
        avatar: '',
        phone: '',
        code: '',
        email: ''
      }
      Object.assign(info, data)

      return common.myFetch(config.apis.Usr_update, info)
      .then(r => {
        if (r) {
          this.$toast(r.msg)
          // this.modifyTel.close()

          return r.avatar
        }
      })
    },
    load() {
      // 加载js文件
      if (window.Stream) {
        return new Promise((r, j) => {r(true)})
      }

      return common.load(config.streamjs)
    },
    getConfig() {
      return common.getFileConfigs()
      .then(r => {
        this.baseUrl = r.url
        this.appId = r.app_id
        this.appSecret = r.app_secret

        const dataConfig = {
          tokenURL: this.baseUrl + config.apis.File_get_token,
          uploadURL: this.baseUrl + config.apis.File_post,
          postVarsPerFile : {
              appId: this.appId,
              appSecret: this.appSecret
          }
        }

        Object.assign(this.picConfig, dataConfig, common.userKeys())
        return true
      })
    },
    configUpload() {
      // 配置上传接口
      Promise.all([this.load(), this.getConfig(), this.getAsperaConfig()]).then(() => {
        this.picStream = new Stream(this.picConfig)
      })
    },
    getAsperaConfig() {
      // 获取aspera上传配置
      return common.myFetch(config.apis.File_Aspera)
      .then(r => {
        if (r) {
          window._XN_upCfg = {
            asperaPath: r.aspera_path,
            httpPath: r.original_path,
            fileNameId: r.filename_id
          }

          return true
        }
      })
    },
    changeAvatar(p) {
      const data = {
        avatar: p
      }

      this.saveUser(data)
      .then((a) => {
        if (a) {
          this.avatar = a
          dc.delUsrInfo()
        }
      })
    },
    async resetPwd1() {
      // 重置密码接口
      if (this.reset.new !== this.reset.new2) {
        this.$toast('密码不一致')
        return
      }
      const origin = await common.encrypt(this.reset.origin)
      const new1 = await common.encrypt(this.reset.new)
      const new2 = await common.encrypt(this.reset.new2)

      const info = {
        oldpassword: origin,
        password: new1,
        repassword: new2
      }

      common.myFetch(config.apis.Usr_reset_pwd, info)
      .then((r) => {
        if (r) {
          if(!r.needVerify){
            this.$toast(r)
            common.clearUser()

            this.$router.push({
              path: '/login'
            })
          }
        }
      })
    },
    async resetPwd() {

      if (this.reset.new !== this.reset.new2) {
        this.$toast('密码不一致')
        return
      }

      const origin = await common.encrypt(this.reset.origin)
      const new1 = await common.encrypt(this.reset.new)
      const new2 = await common.encrypt(this.reset.new2)

      const info = {
        oldpassword: origin,
        password: new1,
        repassword: new2,
        is_validate: 1
      }

      common.myFetch(config.apis.Usr_reset_pwd, info)
      .then((r) => {
        if(r){
          if(!r.needReBind && !r.needVerify){
            this.showPasswordRelative = true
          }
        }
        // console.log(r)
      })
      // 重置密码接口
      // if (this.reset.new !== this.reset.new2) {
      //   this.$toast('密码必须保持一致')
      //   return
      // }
      // const origin = await common.encrypt(this.reset.origin)
      // const new1 = await common.encrypt(this.reset.new)
      // const new2 = await common.encrypt(this.reset.new2)

      // const info = {
      //   oldpassword: origin,
      //   password: new1,
      //   repassword: new2
      // }

      // common.myFetch(config.apis.Usr_reset_pwd, info)
      // .then((r) => {
      //   if (r) {
      //     if(!r.needVerify){
      //       this.$toast(r)
      //       common.clearUser()

      //       this.$router.push({
      //         path: '/login'
      //       })
      //     }
      //   }
      // })
    },
    locateTab() {
      // 自动定位到指定tab
      const tab = this.$route.params.tab || '账户设置'

      this.activeTab = tab
    },
    getMenu() {
      // 左侧边栏数据
      return common.myFetch(config.apis.Site_menu, {data: {}, hideLoading: true})
      .then(r => {
        if (r) {
          return r
        }
      })
    },
    async getShowAuth() {
      let showAuth = await this.getMenu()
      this.showAuth = showAuth
    }
  },
  mounted() {
    // console.log(this.$route)
    this.avatar = this.$_syscfg.default_avatar
    this.getShowAuth()
    this.locateTab()
    this.getUser()
    this.configUpload()
    this.getNewMediaPlatform()
    this.getRedirectSystems()
    

    this.$nextTick(() => {
      if(this.$route.params.type == 'auth'){
        this.activeTab = '已授权'
      }
    })
    // this.$BPlus()
    // this.$MediaPlatformManage()
    // this.$auditProcess()
  }
}
</script>

<style lang="less" scoped src="@assets/css/user.less"></style>
